import React, { useState, useRef } from 'react';
import { Button } from 'quantux-ui';
import DocWriter from '../components/doc-writer';

const TestPage = () => {
  const [showDocWriter, setShowDocWriter] = useState(false);
  const imageRef = useRef();

  return (
    <div className='p-2'>
      <div className='m-2'>
        <Button
          btnType='primary'
          onClick={() => setShowDocWriter(true)}
        >
          Show DocWriter
        </Button>
      </div>
      {showDocWriter &&
        <DocWriter
          imageHeight={imageRef.current ? imageRef.current.style.height : 800}
          src='https://quantumtrader.s3.amazonaws.com/fsdemo.png'
          imageUrl='https://quantumtrader.s3.amazonaws.com/fsdemo.png'
          onSave={() => setShowDocWriter(false)}
          onClose={() => setShowDocWriter(false)}
        />
      }
      <img
        id='hello1211'
        ref={imageRef}
        src='https://quantumtrader.s3.amazonaws.com/fsdemo.png'
        style={{
          maxWidth: '100%',
          width: '100%',
          height: 'auto'
        }}
      />
    </div>
  );
};

export default TestPage;
